// @flow
import { makeGetRequest } from './utils'

import type { ResponseAPI } from './types/api'
import type { Language } from './types/languages'

export const getLanguages = (domain: string): Promise<ResponseAPI<Array<Language>>> =>
  makeGetRequest(`${domain}/client/api/languages`)
